// extracted by mini-css-extract-plugin
export default {"notes":"Activity_RegionVariant_Providers_notes__98aMv"};